import React, { useState } from "react";
import ShowAll from "./components/ShowAll/ShowAll";

interface CustomProps {
  setToggle: any;
  toggle: any;
}

const Team = (_props: CustomProps) => {
  const [tabValue] = useState<string>("Show All");

  function getContent() {
    switch (tabValue) {
      case "Show All":
        return <ShowAll />;
      default:
        return null;
    }
  }

  return (
    <div className="mx-auto flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] w-full max-w-[2400px] flex-col overflow-hidden bg-white p-3 desktop:p-4 screen:p-5 wide:p-6">
      {getContent()}
    </div>
  );
};

export default Team;
